import { LOGIN_REDIRECT } from '../actions/types';

export default function reducerLoginRedirect(state = '', action) {
    switch (action.type) {
        case LOGIN_REDIRECT:
            return action.payload;
        default:
            return state;
    }
}
